import { color, DropdownMenu } from 'stylist'
import styled, { css } from 'react-emotion'

const disabledStyle = ({ disabled, theme }) =>
  disabled &&
  css`
    color: ${color('cadet', { theme })};

    &&:hover,
    &&:active,
    &&:focus {
      background: ${color('white', { theme })};
      color: ${color('cadet', { theme })};
      cursor: not-allowed;
    }
  `

export const DangerDropdownMenuItem = styled(DropdownMenu.Item)`
  color: ${color('red')};

  &&:hover,
  &&:active,
  &&:focus {
    background: ${color('red')};
    color: ${color('white')};
  }

  ${disabledStyle};
`

export default DangerDropdownMenuItem



// WEBPACK FOOTER //
// ./src/components/DangerDropdownMenuItem.js